import appLogger from "@next-platform/client-common-core/logger/appLogger";
import React from "react";

const rulebookHudBoundaryLogger = appLogger.withTag("RulebookHud");

type RulebookHudErrorBoundaryProps = {
  children: React.ReactNode;
  /** Changing key (new conversation/character/message) recovers the HUD after an error. */
  resetKey?: string;
};

type RulebookHudErrorBoundaryState = {
  hasError: boolean;
};

/**
 * Keeps a failure inside the Rulebook HUD (a render error on an unexpected snapshot payload) from reaching
 * the chat page's error boundary: the HUD just disappears and the error is logged.
 */
class RulebookHudErrorBoundary extends React.Component<RulebookHudErrorBoundaryProps, RulebookHudErrorBoundaryState> {
  state: RulebookHudErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): RulebookHudErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown): void {
    rulebookHudBoundaryLogger.error("Rulebook HUD failed and was hidden:", error);
  }

  componentDidUpdate(prevProps: RulebookHudErrorBoundaryProps): void {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render(): React.ReactNode {
    return this.state.hasError ? null : this.props.children;
  }
}

export default RulebookHudErrorBoundary;
